import { useState } from 'preact/hooks';

const useModal = () => {
  const [isModalShowing, setIsShowing] = useState([]);

  function toggleModal(id) {
    const isModalShowingCopy = Object.assign({}, isModalShowing);
    isModalShowingCopy[id] = !isModalShowingCopy[id]
    setIsShowing(isModalShowingCopy);
  }

  return {
    isModalShowing,
    toggleModal
  };
};

export default useModal;